// removed by extract-text-webpack-plugin
module.exports = {"VaccButton":"VaccButton__VaccButton__3jEB8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeControl/VaccButton/VaccButton.css
// module id = 82
// module chunks = 0